import { convertLabelMapToConfig, mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.CompleteTestByAgreementWithClient`]: 'Complete Test by Agreement with Client',
      [`${prefix}.Preparation.MaterialLargerThan37_5mm`]: 'Material Larger than 37.5mm',

      [`${prefix}.TestPortions.HeightColTopSoil1`]: 'Top of Collar to Sample',
      [`${prefix}.TestPortions.HeightColTopSoil2`]: '',
      [`${prefix}.TestPortions.HeightColTopSoil3`]: '',
      [`${prefix}.TestPortions.HeightColTopSoil4`]: '',
      [`${prefix}.TestPortions.MeanSoilHeight`]: 'Average',
      [`${prefix}.TestPortions.SampleHeight`]: 'Sample Height',
    })
  );

export default getLabelConfig;
